export interface ConfigModel {
  id: number;
  configValue: string;
  key: string;
  valueDatatype: string;
  color: string;
  isRange: boolean;
}

export const ValueDatatypeList = [
  {id: 'D', name: 'DATE'},
  {id: 'S', name: 'TEXT'},
  {id: 'N', name: 'NUMBER'},
  {id: 'T', name: 'TIME'},
  {id: 'B', name: 'BOOLEAN'},
  {id: 'I', name: 'INTEGER'}
];

export const ValueBooleanList = [
  {id: 'true', name: 'true'},
  {id: 'false', name: 'false'},
];